import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import "./../image-gallery.css";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Андрей Тадеуш Костюшко';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <div className="onehalf-col-cell">
                        <h2>{title}</h2>
                        <p className="sub">Andrzej Tadeusz Воnаwentura Kosciuszko</p>
                        <p>Брестчина - родина Андрея Тадеуша Костюшко</p>
                    </div>
                </div>

                <div className="pageitem">
                    <p><strong>Андрей Тадеуш Бонавентура Костюшко</strong> родился 4 февраля 1746г. в усадебном доме фольварка Меречёвщина «графства Коссовского» (теперь Ивацевичский район Брестской области Республики Беларусь).</p>
                    <p>Данная дата рождения Костюшко названа биографом Тадеушем Корзоном и другими историками исходя из метрической выписки под номером 478 Коссовской костёльной книги, в которой указано: «1746 12 февраля пастор Раймонд Корсак, наместник настоятеля монастыря Доминиканов Гощевских, крестил дитя - сына законных родителей, именем Андрей Тадеуш Бонавентура,- ясновельможных Людвика Тадеуша и Текли с Ратомских Костюшко, мечных воеводства Берестейского. Кумовьями были: вельможный господин Казимир Наркусский, староста кушлицкий, и вельможная госпожа с Протасевичей Суходольская; вельможный господин Протасевич, староста Пинский и вельможная госпожа Суходольская, писарка земская Слонимская».</p>
                    <p>По мнению белорусских историков (Иосиф Юхо, Владимир Емельянчик и др.) новорождённое дитя крестили вначале в униатской церкви (по желанию матери) и назвали Андреем в честь апостола Андрея Первозванного. По мнению польских учёных (Тадеуш Корзон, Юлиан Немцевич, Юзеф Крашевский и др.), а также швейцарского исследователя Карла Фалькенштейна маленького Костюшко назвали в честь святого Андрея Карсини, бискупа фезулянского, день празднования которого выпадает на 4 февраля.</p>
                    <p>Два других имени Костюшко дали по настоянию отца в честь святого Тадеуша и святого Бонавентури, широко отмечаемых и почитаемых католической церковью.</p>
                </div>

                <div className="pageitem">
                    <ul>
                        <li><Link to='/vtur-kosciuszko-memorial-sign'>Памятный знак. 1999-2006 г.г.</Link></li>
                        <li><Link to='/vtur-kosciuszko-short-biography'>Краткая биография</Link></li>
                        <li><Link to='/vtur-benzyaruk-pedigree-of-the-kostyushkas-of-siakhnowitz'>Радавод сяхновіцкіх Касцюшкаў. Бензярук</Link></li>
                        <li><Link to='/vtur-nestsyarchuk-house-estate-of-tadeusz-kosciuszko'>Дом-усадьба Тадеуша Костюшко. Несцярчук</Link></li>
                        <li><Link to='/vtur-benzyaruk-tadeusz-kosciuszko'>Тадэвуш Касцюшка. Бензярук</Link></li>
                        <li><Link to='/vtur-benzyaruk-birth-of-kosciuszko'>Нараджэнне Касцюшкі. Бензярук</Link></li>
                        <li><Link to='/vtur-kosciuszko-opening-house'>Открыт Мемориальный Дом-музей Костюшко</Link></li>
                    </ul>
                </div>
            </div>
        </>
    );
}